import React from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useAppMeta } from "hooks";

import { useAddShipmentLoadingMutation } from "store/services/shipmentLoadingApi";

import DriverShipmentLoadingForm from "../DriverShipmentLoadingForm";

const DriverShipmentLoadingCreateScreen = () => {

    const navigate = useNavigate();

    const breadcrumbs = [
        { title: "Shipment Loading", path: "/app/driver/loading" },
        { title: "New Shipment Loading" }];

    const [createShipmentLoading, { isLoading: creatingShipmentLoading }] =
        useAddShipmentLoadingMutation();

    // methods
    const handleAddLoading = async (data) => {

        try {
            const { _id } = await createShipmentLoading(data).unwrap();
            toast.success("Shipment Loading Created !");
            navigate(`/app/driver/loading/${_id}/detail`)
        } catch (error) {
            toast.error(
                error?.data?.message ?? error.message ?? "Could Not Created Shipment Loading !"
            );
        }
    }
    useAppMeta("New Shipment Loading");
    return (
        <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingShipmentLoading}>
            <BreadcrumbLayout.Paper>
                <DriverShipmentLoadingForm isBusy={creatingShipmentLoading} onSubmit={handleAddLoading} />
            </BreadcrumbLayout.Paper>

        </BreadcrumbLayout>
    )
}

export default DriverShipmentLoadingCreateScreen